
import { Link } from 'react-router-dom';
import { trails, playgrounds, sportsFacilities } from '../../../mocks/parks';

export default function FeaturedParks() {
  // Combine featured items from all categories and limit to 4
  const featured = [
    ...trails.filter((t) => t.featured),
    ...playgrounds.filter((p) => p.featured),
    ...sportsFacilities.filter((s) => s.featured),
  ].slice(0, 4);

  // If for any reason the data is missing or malformed, render nothing instead of breaking the UI
  if (!Array.isArray(featured) || featured.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              Featured Locations
            </h2>
            <p className="text-gray-500">
              Most popular parks and facilities loved by Roseville residents
            </p>
          </div>
          <a
            href="#all"
            className="text-emerald-600 hover:text-emerald-700 font-medium text-sm whitespace-nowrap cursor-pointer hidden md:block"
          >
            View All Locations <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-emerald-500 text-white text-xs font-semibold rounded-full">
                    {item.type}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs font-semibold text-gray-800">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-gray-900 mb-1 group-hover:text-emerald-600 transition-colors">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-500 line-clamp-2 mb-3">
                  {item.description}
                </p>
                <div className="flex items-center gap-1 text-xs text-gray-400">
                  <i className="ri-map-pin-line"></i>
                  <span className="truncate">{item.address}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
